module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2015/september-3c3765bbdc277e6743031b7e483c4f0b.png";